"use client";
import { UserOutlined } from "@ant-design/icons";
import React from "react";

import { getPanelUrl } from "@/app/constants/general";

interface LoginButtonProps {
  title?: string;
}

const LoginButton = ({ title }: LoginButtonProps) => {
  return (
    <a
      href={`${getPanelUrl()}login`}
      target="_blank"
      rel="noopener noreferrer"
      className="flex text-xs cursor-pointer shrink-0 !text-white rounded-lg font-semibold !bg-regal-blue items-center justify-center px-3 py-2.5"
    >
      <UserOutlined className="text-white text-base" />
      {title && <span className="headerButtonTitle ps-2">{title}</span>}
    </a>
  );
};

export default LoginButton;
